export enum XmVirtualOption {    
    All = 0,
    Cpra0 = 2,
    Cpra80 = 3,
    Cpra95 = 4,
    None = 5
}